export default __webpack_public_path__ + "static/media/im-wald-im-schoene-grueene-wald.1a3e30c1.png";